export default __webpack_public_path__ + "static/media/fc-icon-32-grey.60e2beac.svg";